module.exports = __webpack_public_path__ + "img/delete-icon.a6029d89.svg";